module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_8-83dc0073a471d95f4cb6f92d3f3f52b2.png";